const testsData = [
  {
    id: 1,
    title: "Módulo 1: Evaluación del Reglamento Atlas Investments",
    description: "Preguntas relacionadas con el reglamento interno de trabajo.",
    questions: [
      {
        question:
          "¿Cuál es el objetivo principal del reglamento interno de trabajo?",
        options: [
          "Regular la relación laboral entre la empresa y sus empleados.",
          "Establecer las normas de comportamiento para los clientes.",
          "Organizar el sistema financiero de la empresa.",
          "Establecer las políticas de seguridad.",
        ],
        correctAnswer: 0,
      },
      {
        question:
          "¿Qué información debe incluirse en el registro de cada trabajador?",
        options: [
          "Nombre, cédula y cargo.",
          "Nombre, dirección y salario.",
          "Dirección, teléfono y experiencia.",
          "Nombre y estado civil.",
        ],
        correctAnswer: 0,
      },
      // Agregar más preguntas...
    ],
  },
  {
    id: 2,
    title: "Evaluación para Account Managers",
    description: "Evaluación de fundamentos, competencias, marketing y procesos para el rol de Account Manager.",
    questions: [
      // Parte 1
      {
        question: "¿Qué rol desempeña el Account Manager en Quick Lending?",
        type: "multiple",
        options: [
          "Asesorar en la compra de bienes raíces",
          "Supervisar las transacciones y comunicarse con el cliente",
          "Emitir aprobaciones finales del préstamo",
          "Realizar tasaciones de propiedades"
        ],
        correctAnswer: 1,
      },
      {
        question: "¿Qué valores fundamentales de Quick Lending debe reflejar un Account Manager en su trabajo diario?",
        type: "multiple",
        options: [
          "Innovación, puntualidad, trabajo remoto",
          "Confianza, servicio al cliente, excelencia",
          "Eficiencia, autonomía, ventas agresivas",
          "Formalidad, comunicación limitada, resultados inmediatos"
        ],
        correctAnswer: 1,
      },
      {
        question: "¿Cuál es el propósito del video introductorio del CEO?",
        type: "multiple",
        options: [
          "Explicar los pasos del procesamiento",
          "Capacitar sobre marketing digital",
          "Describir las expectativas del rol y su impacto en la empresa",
          "Enseñar sobre productos hipotecarios"
        ],
        correctAnswer: 2,
      },
      {
        question: "¿Cómo se debe documentar un nuevo lead en Asana?",
        type: "multiple",
        options: [
          "Enviar un mensaje al equipo de procesamiento",
          "Crear un subtask en la carpeta de QL LEADS bajo tu nombre",
          "Enviar un correo al gerente de la sucursal",
          "Abrir un chat de WhatsApp con el cliente"
        ],
        correctAnswer: 1,
      },
      // Parte 2
      {
        question: "¿Cuál de estos escenarios requiere un producto Non-QM?",
        type: "multiple",
        options: [
          "Cliente con puntaje de crédito 750 y salario fijo",
          "Cliente autónomo con ingresos variables pero altos",
          "Comprador de vivienda por primera vez con puntaje 720",
          "Refinanciamiento de vivienda principal"
        ],
        correctAnswer: 1,
      },
      {
        question: "¿Qué herramienta es fundamental para registrar las actualizaciones de escenarios de clientes?",
        type: "multiple",
        options: [
          "WhatsApp",
          "Google Docs",
          "Asana",
          "Floify"
        ],
        correctAnswer: 2,
      },
      {
        question: "¿Qué técnica se utiliza para mejorar las habilidades de comunicación durante la capacitación?",
        type: "multiple",
        options: [
          "Role-play de llamadas con clientes ficticios",
          "Crear escenarios de préstamos",
          "Simulación de evaluación de leads",
          "Revisión de contratos antiguos"
        ],
        correctAnswer: 0,
      },
      {
        question: "¿Cuál es el objetivo de la actividad de shadowing?",
        type: "multiple",
        options: [
          "Generar leads en redes sociales",
          "Observar interacciones reales para aprender técnicas de comunicación efectiva",
          "Crear campañas de marketing digital",
          "Evaluar clientes con el equipo de procesamiento"
        ],
        correctAnswer: 1,
      },
      // Parte 3
      {
        question: "¿Qué pasos son esenciales para diseñar una campaña de marketing digital?",
        type: "multiple",
        options: [
          "Crear flyers para clientes y establecer citas telefónicas",
          "Definir audiencia, seleccionar plataformas y planificar contenido",
          "Buscar leads en aplicaciones y enviar correos masivos",
          "Asistir a entrenamientos de marketing sin implementarlos"
        ],
        correctAnswer: 1,
      },
      {
        question: "¿Qué estrategia es más efectiva para captar leads en el sector hipotecario?",
        type: "multiple",
        options: [
          "Llamadas en frío a listas de clientes antiguos",
          "Publicaciones en redes sociales con contenido informativo",
          "Enviar mensajes automatizados por WhatsApp",
          "Publicidad en periódicos locales"
        ],
        correctAnswer: 1,
      },
      {
        question: "¿Qué plataforma utiliza Quick Lending para gestionar leads y tareas?",
        type: "multiple",
        options: [
          "WhatsApp",
          "Asana",
          "CRM de Salesforce",
          "Floify"
        ],
        correctAnswer: 1,
      },
      {
        question: "¿Qué incluye el simulacro de gestión de un cliente en el CRM?",
        type: "multiple",
        options: [
          "Solo ingresar los datos del cliente",
          "Ingresar el perfil del cliente y gestionar el seguimiento hasta el cierre",
          "Enviar un correo de bienvenida al cliente",
          "Crear una cotización y enviarla al procesador"
        ],
        correctAnswer: 1,
      },
      // Parte 4
      {
        question: "¿Cuál es el primer paso al recibir un contrato?",
        type: "multiple",
        options: [
          "Pedir un appraisal",
          "Enviar un email de bienvenida al cliente",
          "Abrir Asana y actualizar la carpeta del proyecto",
          "Llamar al realtor para confirmar detalles"
        ],
        correctAnswer: 2,
      },
      {
        question: "¿Qué información incluye el Preliminary HUD enviado al cliente?",
        type: "multiple",
        options: [
          "Solo el monto total del préstamo",
          "Detalles del precio de venta, pago inicial y posible tasa de interés",
          "La tasa de interés fija y el plazo del préstamo",
          "El monto final a desembolsar"
        ],
        correctAnswer: 1,
      },
      {
        question: "¿Qué acción es fundamental al enfrentar discrepancias en el valor de un appraisal?",
        type: "multiple",
        options: [
          "Esperar a que el cliente lo resuelva con el realtor",
          "Descartar la transacción y buscar un nuevo lead",
          "Negociar el precio de venta o buscar un valor BPO alternativo",
          "Pedir una evaluación manual del cliente"
        ],
        correctAnswer: 2,
      },
      {
        question: "¿Cuántas horas tiene el Account Manager para responder a un lead antes de que otro lo pueda tomar?",
        type: "multiple",
        options: [
          "8 horas",
          "12 horas",
          "24 horas",
          "48 horas"
        ],
        correctAnswer: 2,
      },
      // Parte 5
      {
        question: "¿Qué es obligatorio incluir al comunicarse con un lender?",
        type: "multiple",
        options: [
          "Los datos del cliente y la dirección de la transacción",
          "Solo el número de contrato",
          "Un correo de referencia de otro cliente",
          "Una copia del Preliminary HUD"
        ],
        correctAnswer: 0,
      },
      {
        question: "¿Cuál es el objetivo principal de un email de aprobación al cliente?",
        type: "multiple",
        options: [
          "Detallar los pasos finales para cerrar el préstamo",
          "Confirmar la tasa de interés fija del préstamo",
          "Solicitar documentos adicionales para la transacción",
          "Aclarar las condiciones del appraisal"
        ],
        correctAnswer: 0,
      },
      {
        question: "¿Qué acción está prohibida al comunicarse con un cliente con documentos pendientes?",
        type: "multiple",
        options: [
          "Usar WhatsApp para enviar mensajes",
          "No registrar la llamada en Asana",
          "Enviar únicamente mensajes de texto sin hacer una llamada",
          "Informar al realtor sobre la situación"
        ],
        correctAnswer: 2,
      },
      {
        question: "¿Cómo se asegura la eficiencia en el manejo de leads según el protocolo de Quick Lending?",
        type: "multiple",
        options: [
          "Manteniendo un seguimiento semanal con el realtor",
          "Registrando los pendientes y avances en Asana",
          "Realizando reuniones diarias para revisar contratos",
          "Usando solo comunicación verbal con los clientes"
        ],
        correctAnswer: 1,
      },
      // Retroalimentación en vivo (Abiertas)
      {
        question: "¿Cómo integrarías lo aprendido en este módulo para manejar un caso en el que un cliente necesita renegociar su contrato debido a una discrepancia en el appraisal? (Pregunta para retroalimentación en vivo)",
        type: "open"
      },
      {
        question: "¿Qué estrategias usarías para asegurar la satisfacción del cliente mientras gestionas un lead asignado por el call center? (Pregunta para retroalimentación en vivo)",
        type: "open"
      }
    ]
  }
];
export default testsData;
